import classnames from 'classnames';
import { Field } from 'formik';
import { isNil } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import style from './EntityFieldContent.scss';
import useEntityFormContext from './useEntityFormContext';
import useLayoutDirection from '../../../utils/Translations/useLayoutDirection';
const LEFT_PULL_CLASS = 'pull-left';
const RIGHT_PULL_CLASS = 'pull-right';
export const resolveRTLWrapperClassName = (wrapperClassName) => {
    const classTokens = wrapperClassName.split(/\s+/).filter(Boolean);
    let hasPullClass = false;
    const resolvedTokens = classTokens.map(token => {
        if (token === LEFT_PULL_CLASS) {
            hasPullClass = true;
            return RIGHT_PULL_CLASS;
        }
        if (token === RIGHT_PULL_CLASS) {
            hasPullClass = true;
            return LEFT_PULL_CLASS;
        }
        return token;
    });
    if (!hasPullClass) {
        resolvedTokens.push(RIGHT_PULL_CLASS);
    }
    return resolvedTokens.join(' ');
};
export const DEFAULT_WRAPPER_CLASS_NAMES = {
    default: 'col-lg-4 col-md-6 col-sm-12 col-xs-12',
    0: '',
    1: 'col-lg-12 col-md-12 col-sm-12 col-xs-12',
    2: 'col-lg-6 col-md-6 col-sm-12 col-xs-12',
    3: 'col-lg-4 col-md-6 col-sm-12 col-xs-12',
    4: 'col-lg-3 col-md-6 col-sm-12 col-xs-12',
    6: 'col-lg-2 col-md-2 col-sm-12 col-xs-12',
    10: 'col-lg-1p5 col-md-2 col-sm-12 col-xs-12',
    12: 'col-lg-1 col-md-2 col-sm-3 col-xs-4',
    1.1: 'col-xs-11',
    1.2: 'col-xs-10',
    [-1]: 'inline pull-left',
};
const EntityFieldContent = (props) => {
    const { direction, isLayoutRTL } = useLayoutDirection();
    const { name, columns, removeButton, addButton, isPageTitle, children, autoFilledValue, ...restProps } = props;
    const { hasClearOnUnregister, wrapperClassNames = {} } = restProps;
    const { setFieldValue, setFieldTouched } = useEntityFormContext();
    useEffect(() => {
        var _a;
        if ((props === null || props === void 0 ? void 0 : props.inputDefaultValue) && (props === null || props === void 0 ? void 0 : props.input))
            (_a = props === null || props === void 0 ? void 0 : props.input) === null || _a === void 0 ? void 0 : _a.onChange(props === null || props === void 0 ? void 0 : props.inputDefaultValue);
    }, [props === null || props === void 0 ? void 0 : props.inputDefaultValue]);
    useEffect(() => () => {
        if (hasClearOnUnregister) {
            setFieldValue(name, null);
            setFieldTouched(name, false);
        }
    }, [hasClearOnUnregister, name, setFieldTouched, setFieldValue]);
    useEffect(() => {
        if (autoFilledValue) {
            setFieldValue('launchpadLabel', autoFilledValue);
            setFieldTouched('launchpadLabel', true);
        }
    }, [autoFilledValue]);
    const wrapperClassName = useMemo(() => {
        const key = !isNil(columns)
            ? columns
            : 'default';
        if (wrapperClassNames && key in wrapperClassNames) {
            return wrapperClassNames[key];
        }
        return DEFAULT_WRAPPER_CLASS_NAMES[key];
    }, [columns, wrapperClassNames]);
    const resolvedWrapperClassName = useMemo(() => {
        if (!isLayoutRTL || !wrapperClassName) {
            return wrapperClassName;
        }
        return resolveRTLWrapperClassName(wrapperClassName);
    }, [isLayoutRTL, wrapperClassName]);
    const field = (<div className={classnames(resolvedWrapperClassName, isPageTitle && style.pageTitle)} data-layout-direction={direction} dir={direction}>
      <Field name={name} {...restProps} childrenFunc={children}/>
    </div>);
    const actions = removeButton && (<div className="col-xs-1" data-layout-direction={direction} dir={direction}>
      <div className={classnames('form-group form-group-material', style.removeButton)}>
        {removeButton}
        {addButton}
      </div>
    </div>);
    return (<>
      {isLayoutRTL && actions}
      {field}
      {!isLayoutRTL && actions}
    </>);
};
export default EntityFieldContent;
